<template>
  <!-- eslint-disable -->
  <div>
    <detalle-filters />
    <b-card no-body class="mb-0">
      <b-table
        class="position-relative border border-2 rounded"
        :hover="true"
        :items="records"
        responsive
        :fields="fields"
        show-empty
        empty-text="No existen"
        @sort-changed="sortChanged"
        :head-variant="'dark'"
      >
        <template #cell(precio)="data">
          {{ '$' + data.value }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button size="sm" class="" v-b-tooltip.hover.top="'Editar'" variant="flat-success">
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button size="sm" class="" v-b-tooltip.hover.top="'Eliminar'" variant="flat-danger">
              <feather-icon icon="Trash2Icon" />
            </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col sm="3">
            <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
              <b-form-select
                v-model="showEntrie"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="entries"
                @change="changeSizePage"
              />
            </b-form-group>
          </b-col>
          <b-col sm="3" class="mt-75" style="font-size: 12px">
            <span> {{ totalElements }} Registros en total</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalElements"
              :per-page="showEntrie"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="cambioPagina"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import detalleFilters from './detalleFilters.vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [
        {
          id: 1,
          cod_ori: '12421',
          cod_alter: '',
          descripcion: 'AMORT. TOYOTA TERCEL 96/99 POST.CORSA/ STARLET',
          marca: 'KYB',
          vehiculo: 'Toyota',
          stock: 2,
          precio: 81.75
        },
        {
          id: 2,
          cod_ori: '43634',
          cod_alter: '',
          descripcion: 'AMORT. TOYOTA TERCEL asdasdasd',
          marca: 'KYB',
          vehiculo: 'Toyota',
          stock: 3,
          precio: 51.75
        },
        {
          id: 3,
          cod_ori: '8658',
          cod_alter: '',
          descripcion: 'AMORT. TOYOTA TERCEL 6426264',
          marca: 'KYB',
          vehiculo: 'Toyota',
          stock: 5,
          precio: 11.75
        }
      ],
      fields: [
        { key: 'id', label: 'Nº', sortable: false },
        { key: 'cod_ori', label: 'Codigo Original', sortable: true },
        { key: 'cod_alter', label: 'Codigo Alter.', sortable: true },
        { key: 'descripcion', label: 'Descripción', sortable: false },
        { key: 'marca', label: 'Marca', sortable: true },
        { key: 'vehiculo', label: 'Vehiculo', sortable: true },
        { key: 'stock', label: 'Stock General', sortable: true },
        { key: 'precio', label: 'Precio (US$)', sortable: false },
        { key: 'actions', label: 'Seleccionar' }
      ],
      cont: 1,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components: {
    detalleFilters
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    }
  }
}
</script>

<style></style>
